export default {
  /**
   * Issues state structuring
   *
   * Issues {
   *  // data will contain all Jira issues of the company
   *  data: {
   *    issueKey: {
   *      attachments: [ // If you are on this issue, this property will be added
   *        // Array who contain all attachments
   *      ]
   *      attachmentsLoading: true/false  // If you are on this issue, this property will be added
   *      author: (...)
   *      comments: (...) [ // If you are on this issue, this property will be added
   *        // Array who contain all comments
   *      ]
   *      commentsLoading: true/false // If you are on this issue, this property will be added
   *      description: (...)
   *      expand: (...)
   *      fields: (...)
   *      id: (...)
   *      issueLoading: true/false // If you are on this issue, this property will be added
   *      key: (...)
   *      self: (...)
   *      statusId: (...)
   *    }
   *  }
   *  issuesLoading: true/false
   * }
   */
  issues: {
    data: {},
    issuesLoading: false,
  },
};
